import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'vex-mail-remarks-dialog',
  standalone: true,
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p class="mail-remarks-dialog__message">{{ data.message }}</p>
      <mat-form-field appearance="outline" class="mail-remarks-dialog__field">
        <mat-label>{{ data.label || 'Remarks' }}</mat-label>
        <textarea [(ngModel)]="remarks" matInput rows="4"></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">Cancel</button>
      <button mat-flat-button color="primary" type="button" (click)="dialogRef.close((remarks || '').trim())">
        {{ data.confirmText || 'Save' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .mail-remarks-dialog__message {
      margin: 0 0 16px;
      color: var(--vex-color-text-secondary);
      line-height: 1.5;
    }
    .mail-remarks-dialog__field {
      width: 100%;
    }
  `],
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule]
})
export class MailRemarksDialogComponent {
  readonly dialogRef = inject(MatDialogRef<MailRemarksDialogComponent, string>);
  readonly data = inject<{
    title: string;
    message: string;
    label?: string;
    confirmText?: string;
  }>(MAT_DIALOG_DATA);

  remarks = '';
}
